// extracted by mini-css-extract-plugin
module.exports = {"Loader":"Spinner_Loader__1twK-","load2":"Spinner_load2__2gkgc"};